import React, { useEffect } from "react";
import HomeReviews from "../components/homepage-components/HomeReviews";
import Faq from "../components/universal-components/Faq";
import Hero from "../components/Hero";
import Intro from "../components/Intro";
import ContentLeft from "../components/ContentLeft";
import ContentRight from "../components/ContentRight";
import CallToAction from "../components/CallToAction";
import { bathroomContent } from "../page-content/bathroomContent";

const Bathrooms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Hero data={bathroomContent} />
      <Intro data={bathroomContent} />
      <ContentLeft data={bathroomContent} />
      <ContentRight data={bathroomContent} />
      <CallToAction data={bathroomContent} />
      <HomeReviews />
      <Faq />
    </>
  );
};

export default Bathrooms;
